import { render } from "./withdraw.vue?vue&type=template&id=736a0f6f&scoped=true"
import script from "./withdraw.vue?vue&type=script&lang=js"
export * from "./withdraw.vue?vue&type=script&lang=js"

import "./withdraw.vue?vue&type=style&index=0&id=736a0f6f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-736a0f6f"]])

export default __exports__